"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _common = _interopRequireDefault(require("../common"));
var _anchor = _interopRequireDefault(require("./anchor"));
var _autocomplete = _interopRequireDefault(require("./autocomplete"));
var _button = _interopRequireDefault(require("./button"));
var _buttonCircle = _interopRequireDefault(require("./buttonCircle"));
var _buttonOptions = _interopRequireDefault(require("./buttonOptions"));
var _color = _interopRequireDefault(require("./color"));
var _dropdown = _interopRequireDefault(require("./dropdown"));
var _font = _interopRequireDefault(require("./font"));
var _label = _interopRequireDefault(require("./label"));
var _input = _interopRequireDefault(require("./input"));
var _radiobutton = _interopRequireDefault(require("./radiobutton"));
var _reviewPanel = _interopRequireDefault(require("./reviewPanel"));
var _tag = _interopRequireDefault(require("./tag"));
var _starRating = _interopRequireDefault(require("./starRating"));
var _typeScale = _interopRequireDefault(require("./typeScale"));
var _textField = _interopRequireDefault(require("./textField"));
var _checkbox = _interopRequireDefault(require("./checkbox"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var theme = _objectSpread(_objectSpread({}, _common.default), {}, {
  anchor: _anchor.default,
  autocomplete: _autocomplete.default,
  button: _button.default,
  buttonCircle: _buttonCircle.default,
  buttonOptions: _buttonOptions.default,
  color: _color.default,
  dropdown: _dropdown.default,
  font: _font.default,
  label: _label.default,
  input: _input.default,
  radiobutton: _radiobutton.default,
  reviewPanel: _reviewPanel.default,
  tag: _tag.default,
  starRating: _starRating.default,
  typeScale: _typeScale.default,
  textField: _textField.default,
  checkbox: _checkbox.default
});
var _default = exports.default = theme;